import type { ReactNode } from "react";
import Img from "./img";

/**
 * `tip` is a hover label anchored on the check itself, in CSS (`.badge-tip`,
 * product.scss), so its arrow points at the check. The shared Tooltip centred
 * itself on the whole "Listed By <name>" link and pointed at the name.
 */
const VerifyBadge = ({ user, text: _text = false, tip }: { user?: { trustLevel?: unknown } | null; text?: boolean; tip?: ReactNode }) => {
  return parseInt(String(user?.trustLevel)) >= 2 ? (
    <div className={`badge-cont${tip ? " has-tip" : ""}`}>
      <div className="verify-badge">
        <Img src="/images/svg/checkmark.svg" />
      </div>
      {tip ? <span className="button-tip badge-tip" role="tooltip">{tip}</span> : null}
      {/*{text ? <div className="text">{verifiedSellerLabel}</div> : ""}*/}
    </div>
  ) : (
    ""
  );
};

export default VerifyBadge;
